import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  { id: "graph1", 
    title: "Evolución en el tiempo", 
    menuTitle: "Evolución en el tiempo", 
    text: `En general, niñas y niños de 4º básico se muestran satisfechos con su escuela (89% en 2022) y, como se observa en el gráfico, la satisfacción se 
          ha mantenido relativamente estable en el tiempo. No obstante, recordemos que esta aproximación considera solo la respuesta a la 
          pregunta “me gusta mucho venir a mi escuela”. Algunas investigaciones sugieren que la medición de la satisfacción con la escuela es 
          compleja y que debe incluir diversas dimensiones que permitan entenderla de mejor manera[10]. Por ello sería ideal avanzar hacia la 
          inclusión de más preguntas que permitan caracterizar esta satisfacción de forma más específica.`, 
    link: "https://public.flourish.studio/visualisation/23508147/embed"},

  { id: "graph2", 
    title: "Análisis por sexo", 
    menuTitle: "\u2022 Sexo", 
    text: `En la serie histórica analizada, las niñas presentan una mayor satisfacción con la escuela que los niños. La última medición muestra un 91% contra 
          un 88% respectivamente.`, 
    link: "https://public.flourish.studio/visualisation/23508098/embed"},

  { id: "graph3", 
    title: "Análisis por dependencia administrativa", 
    menuTitle: "\u2022 Dependencia", 
    text: `Al desagregar por dependencia administrativa, se observa que quienes asisten a establecimientos educacionales particulares pagados presentan una 
          proporción mayor de satisfacción con su escuela. Si bien históricamente la satisfacción con la escuela es menor entre las y los estudiantes que 
          asisten a establecimientos educacionales públicos que a particulares subvencionados, en 2022 ambos porcentajes se igualan en un 89%, contra un 93% 
          de los particulares pagados.`, 
    link: "https://public.flourish.studio/visualisation/23508079/embed"},

  { id: "graph4", 
    title: "Análisis por convivencia escolar", 
    menuTitle: "\u2022 Convivencia escolar", 
    text: `Como se menciona en la introducción, la promoción de un ambiente escolar positivo se relaciona de forma directa con la satisfacción que niñas y 
          niños presentan con sus escuelas. Para medir estos ambientes escolares se han utilizado preguntas que reflejan ámbitos relacionales tales como si 
          niñas y niños perciben que los estudiantes de su curso se tratan con respeto, si profesores les tratan con respeto, si los estudiantes cuidan su 
          sala de clases y escuela, y el respeto de las normas de convivencia. Niñas y niños que asisten a escuelas que presentan entornos educativos menos 
          amigables presentan una diferencia estadísticamente significativa en sus niveles de satisfacción con la misma. Esta diferencia se mantiene en el 
          tiempo, y en 2022 fue de 6 puntos porcentuales.`, 
    link: "https://public.flourish.studio/visualisation/23508108/embed"},

  { id: "graph5", 
    title: "Análisis por clima escolar", 
    menuTitle: "\u2022 Clima escolar", 
    text: `En Chile, una investigación reciente demostró que ser víctima de violencia escolar tiene un efecto indirecto en la satisfacción con la vida a 
          través de una disminución de la satisfacción escolar[11]. Para construir este indicador se han utilizado preguntas relacionadas con la vivencia de 
          burlas, golpes u otras formas de acoso escolar. En línea con la literatura, se observa que niñas y niños que viven tres o más formas de acoso 
          escolar (reflejando una mala convivencia escolar) presentan un porcentaje menor de satisfacción con la escuela, en relación a aquellas que no viven 
          estas situaciones de forma sistemática (80% contra 91% en 2022 respectivamente).`, 
    link: "https://public.flourish.studio/visualisation/23508114/embed"},

    { id: "graph6", 
      title: "Análisis por zona de residencia", 
      menuTitle: "\u2022 Zona de residencia", 
      text: `En términos de la zona en la que se encuentra la escuela no se observan diferencias estadísticamente significativas en la serie 
            histórica analizada entre las y los estudiantes de zonas urbanas y rurales.`, 
      link: "https://public.flourish.studio/visualisation/23508088/embed"},
  
    { id: "graph7", 
    title: "Análisis por macrozona", 
    menuTitle: "\u2022 Macrozona", 
    text: `No se observan grandes diferencias en la satisfacción con la escuela de acuerdo a la Macrozona. Niñas y niños que asisten a 
          escuelas ubicadas en la Zona Metropolitana presentan porcentajes levemente menores de satisfacción, si bien estas diferencias no 
          son estadísticamente significativas.`, 
    link: "https://public.flourish.studio/visualisation/23508135/embed"},

  { id: "graph8", 
    title: "Análisis por región", 
    menuTitle: "\u2022 Región", 
    text: `No se observan diferencias según la región en que residen niñas y niños en sus niveles de satisfacción con la escuela.`, 
    link: "https://public.flourish.studio/visualisation/23508142/embed"},

];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;

